import { Plus } from 'lucide-react';
import { Typography } from './Typography';
import styles from './FAQItem.module.css';
export function FAQItem({
  question,
  answer,
  defaultOpen = false,
}: {
  question: string;
  answer: string;
  defaultOpen?: boolean;
}) {
  return (
    <details className={styles.item} open={defaultOpen || undefined}>
      <summary>
        <Typography as="span" variant="cardTitle">
          {question}
        </Typography>
        <Plus size={20} aria-hidden />
      </summary>
      <div className={styles.answer}>
        <Typography tone="muted">{answer}</Typography>
      </div>
    </details>
  );
}
